import {
  GetArticleDetailResponseDTO,
  GetArticleEarningsResponseDTO,
  GetArticleInvestorSummarizeResponseDTO,
  GetArticlePollDetailDTO,
  GetArticleRoleResponseDTO,
  GetDeleteArticleResponseDTO,
  GetInvestorsResponseDTO,
  GetListArticlesResponseDTO,
  GetListReactionParagraphDTO,
  GetListReputationsReceivedResponseDTO,
  GetListResponseDTO,
  GetListSearchResponseDTO,
  GetListTopicResponseDTO,
  GetListUserResponseDTO,
  GetMyInvestmentsResponseDTO,
  GetNewArticleResponseDTO,
  GetPresignedUrlResponseDTO,
  GetReputationPointBalancesResponseDTO,
  GetUserAwardedPointsResponseDTO,
  GetUserResponseDTO,
  GetUserTotalEarningResponseDTO,
  GetWritingTypeResponseDTO,
  PostArticleInteractionIgnoreResponseDTO,
  PostArticleInteractionSaveResponseDTO,
  PostArticleInteractionShareResponseDTO,
  PostArticleInteractionUnIgnoreResponseDTO,
  PostArticleInteractionUnSaveResponseDTO,
  PostArticleInteractionViewResponseDTO,
  PostArticleInvestmentInvestResponseDTO,
  PostArticlePollCastVoteResponseDTO,
  PostReactParagraphDTO,
  PostReputationAwardResponseDTO,
  TopicDTO,
  ProcessThumbnailFromUploadResponseDTO,
  GetArticlesByInvestorResponseDTO
} from '@twygs/shared/publisher-interface';
import axiosInstance from './axios-instance';

export const postAssetUpload = async (data) => {
  try {
    const result: GetPresignedUrlResponseDTO = await axiosInstance.post(
      '/api/v1/publisher/articles/presigned-upload-asset',
      data
    );
    return result.data;
  } catch (error) {
    console.error('Error uploading asset:', error);
    throw error;
  }
};

export const fetchListWrittingType = async () => {
  const result: GetWritingTypeResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/articles/writing-types'
  );
  return result.data;
};

export const fetchListUser = async () => {
  const result: GetListUserResponseDTO = await axiosInstance.get('/api/v1/publisher/user');
  return result.data;
};

export const fetchListRole = async () => {
  const result: GetArticleRoleResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/articles/roles'
  );
  return result.data;
};

export const publishArticle = async (data) => {
  const result: GetNewArticleResponseDTO = await axiosInstance.patch(
    '/api/v1/publisher/articles/publish',
    data
  );
  return result.data;
};

export const saveAsDraft = async (data) => {
  const result: GetNewArticleResponseDTO = await axiosInstance.patch(
    '/api/v1/publisher/articles/save-draft',
    data
  );
  return result.data;
};

export const fetchSearch = async (pagination, userId) => {
  const result: GetListSearchResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/articles/search',
    {
      params: { ...pagination, userId }
    }
  );
  return result.data;
};

export const fetchTopics = async (): Promise<TopicDTO[]> => {
  const result: GetListTopicResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/articles/topics',
    {}
  );
  return result.data;
};

export const fetchArticles = async (params) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get('/api/v1/publisher/articles', {
    params
  });
  return result.data;
};

export const fetchListMyArticles = async (pagination) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/articles/me',
    {
      params: pagination
    }
  );
  return result.data;
};

export const fetchListMyLikedArticles = async (pagination) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/articles/liked',
    {
      params: pagination
    }
  );
  return result.data;
};

export const fetchListLikedArticlesById = async (id, pagination) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/liked-by-id/${id}`,
    {
      params: pagination
    }
  );
  return result.data;
};

export const fetchListReactedArticlesById = async (id, pagination) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/reacted-by-id/${id}`,
    {
      params: pagination
    }
  );
  return result.data;
};

export const fetchListTwigsGivenArticlesById = async (id, pagination) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/twigs-given-by-id/${id}`,
    {
      params: pagination
    }
  );
  return result.data;
};

export const fetchArticlesByIds = async (ids, pagination) => {
  const result = await axiosInstance.get('/api/v1/publisher/articles/by-ids', {
    params: { ...pagination, ids }
  });
  return result.data;
};

export const fetchArticleDetail = async (id, options = {}) => {
  const result: GetArticleDetailResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/${id}/detail`,
    {
      params: {
        ...options
      }
    }
  );
  return result.data;
};

export const fetchArticleRelatedContent = async (id, params) => {
  const result: GetListArticlesResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/related-articles/${id}`,
    { params }
  );
  return result.data;
};

export const getDetailArticleEarnings = async (id) => {
  const result: GetArticleEarningsResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/${id}/earnings`
  );
  return result.data;
};

export const getTotalArticleEarnings = async () => {
  const result: GetUserTotalEarningResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/articles/total-earnings'
  );
  return result.data;
};

export const reactArticle = async (data) => {
  const result: PostReactParagraphDTO = await axiosInstance.post(
    '/api/v1/publisher/articles/interaction/react-paragraph',
    data
  );
  return result.data;
};

export const getListReactOfParagraph = async (id: string, articleId?: string) => {
  const result: GetListReactionParagraphDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/interaction/paragraph/${id}/list`,
    { params: articleId ? { articleId } : undefined }
  );
  return result.data;
};

export const getParagraphReactionUsers = async (
  nodeId: string,
  options: { reactionType?: string; page?: number; limit?: number; articleId?: string }
) => {
  const result = await axiosInstance.get(
    `/api/v1/publisher/articles/interaction/paragraph/${nodeId}/reactions/users`,
    {
      params: {
        reactionType: options.reactionType,
        page: options.page || 1,
        limit: options.limit || 20,
        ...(options.articleId ? { articleId: options.articleId } : {})
      }
    }
  );
  return result.data;
};

export const getArticleReactionUsers = async (
  articleId: string,
  options: { reactionType?: string; page?: number; limit?: number }
) => {
  const result = await axiosInstance.get(
    `/api/v1/publisher/articles/interaction/${articleId}/reactions/users`,
    {
      params: {
        reactionType: options.reactionType,
        page: options.page || 1,
        limit: options.limit || 20
      }
    }
  );
  return result.data;
};

export const viewArticle = async (id) => {
  try {
    const result: PostArticleInteractionViewResponseDTO = await axiosInstance.post(
      '/api/v1/publisher/articles/interaction/view',
      {
        articleId: id
      }
    );
    return result.data;
  } catch (error) {
    console.error('Error view articles:', error);
    throw error;
  }
};

export const shareArticle = async (id) => {
  try {
    const result: PostArticleInteractionShareResponseDTO = await axiosInstance.post(
      '/api/v1/publisher/articles/interaction/share',
      {
        articleId: id
      }
    );
    return result.data;
  } catch (error) {
    console.error('Error share articles:', error);
    throw error;
  }
};

export const deleteArticle = async (id) => {
  try {
    const result: GetDeleteArticleResponseDTO = await axiosInstance.delete(
      `/api/v1/publisher/articles/${id}`
    );
    return result.data;
  } catch (error) {
    console.error('Error deleting articles:', error);
    throw error;
  }
};

export const saveArticle = async (id) => {
  try {
    const result: PostArticleInteractionSaveResponseDTO = await axiosInstance.post(
      '/api/v1/publisher/articles/interaction/save',
      {
        articleId: id
      }
    );
    return result.data;
  } catch (error) {
    console.error('Error deleting requests:', error);
    throw error;
  }
};

export const unsaveArticle = async (id) => {
  try {
    const result: PostArticleInteractionUnSaveResponseDTO = await axiosInstance.post(
      '/api/v1/publisher/articles/interaction/unsave',
      {
        articleId: id
      }
    );
    return result.data;
  } catch (error) {
    console.error('Error deleting requests:', error);
    throw error;
  }
};

export const ignoreArticle = async (id) => {
  try {
    const result: PostArticleInteractionIgnoreResponseDTO = await axiosInstance.post(
      '/api/v1/publisher/articles/interaction/ignore',
      {
        articleId: id
      }
    );
    return result.data;
  } catch (error) {
    console.error('Error deleting requests:', error);
    throw error;
  }
};

export const unignoreArticle = async (id) => {
  try {
    const result: PostArticleInteractionUnIgnoreResponseDTO = await axiosInstance.post(
      '/api/v1/publisher/articles/interaction/unignore',
      {
        articleId: id
      }
    );
    return result.data;
  } catch (error) {
    console.error('Error deleting requests:', error);
    throw error;
  }
};

export const fetchListMediaOfContributor = async () => {
  const result: GetListResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/responses/approved'
  );

  return result.data;
};

export const updateProfile = async (data) => {
  try {
    const result: GetUserResponseDTO = await axiosInstance.post(
      '/api/v1/publisher/user/update',
      data
    );
    return result.data;
  } catch (e) {
    return e?.response.data;
  }
};

export const genPresignUrl = async (data) => {
  const result: GetPresignedUrlResponseDTO = await axiosInstance.post(
    '/api/v1/publisher/user/gen-presigned-url',
    data
  );

  if (result)
    return {
      data: result.data
    };
};

export const getPollData = async (id: string) => {
  const result: GetArticlePollDetailDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/polls/${id}`
  );

  return result.data;
};

export const castVote = async ({ pollId, optionIds }) => {
  const result: PostArticlePollCastVoteResponseDTO = await axiosInstance.post(
    '/api/v1/publisher/articles/polls/cast-vote',
    {
      pollId,
      optionIds
    }
  );

  return result.data;
};

export const getUserTotalAWard = async (id) => {
  const result: GetUserAwardedPointsResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/reputations/user/${id}`
  );
  return result.data;
};

export const getReceivedAwardPointHistory = async (pagination) => {
  const result: GetListReputationsReceivedResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/reputations/received',
    {
      params: pagination
    }
  );
  return result.data;
};

export const getGivenAwardPointHistory = async (pagination) => {
  const result: GetListReputationsReceivedResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/reputations/given',
    {
      params: pagination
    }
  );
  return result.data;
};

export const getInvestmentPointHistory = async (pagination) => {
  const result: GetMyInvestmentsResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/investments/me',
    {
      params: pagination
    }
  );
  return result.data;
};

export const getInvestorsPointList = async (articleId, params) => {
  const result: GetInvestorsResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/investments/${articleId}/investors`,
    {
      params
    }
  );
  return result.data;
};

export const getMyInvestorsPointList = async (params) => {
  const result: GetInvestorsResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/investments/my-investors',
    {
      params
    }
  );
  return result.data;
};

export const getArticleInvestorSummarize = async (params) => {
  const result: GetArticleInvestorSummarizeResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/investments/investor-summarize',
    {
      params
    }
  );
  return result.data;
};

export const getArticleByInvestor = async (investorId, params = {}) => {
  const result: GetArticlesByInvestorResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/articles/investor/${investorId}`,
    {
      params
    }
  );
  return result.data;
};

export const getInvestorSummary = async (investorId) => {
  const result = await axiosInstance.get(
    `/api/v1/publisher/articles/investor/${investorId}/summary`
  );
  return result.data;
};

export const getPointBalance = async () => {
  const result: GetReputationPointBalancesResponseDTO = await axiosInstance.get(
    '/api/v1/publisher/reputations/point-balances'
  );
  return result.data;
};

export const createReputation = async (data) => {
  const result: PostReputationAwardResponseDTO = await axiosInstance.post(
    '/api/v1/publisher/reputations/award',
    data
  );
  return result.data;
};

export const investArticle = async (data) => {
  const result: PostArticleInvestmentInvestResponseDTO = await axiosInstance.post(
    '/api/v1/publisher/articles/investments/invest',
    data
  );
  return result.data;
};

export const listIgnoredArticles = async (pagination) => {
  const result = await axiosInstance.get('/api/v1/publisher/articles/interaction/ignored', {
    params: pagination
  });
  return result.data;
};

export const listIgnoredWriters = async (pagination) => {
  const result = await axiosInstance.get('/api/v1/publisher/user/blocked', {
    params: pagination
  });
  return result.data;
};

export const unignoreWriter = async (id) => {
  const result = await axiosInstance.post(`/api/v1/publisher/user/${id}/unblock`);
  return result.data;
};

export const BuffPoint = async (data) => {
  const result = await axiosInstance.put(
    '/api/v1/publisher/reputations/manual-reputation-point-update',
    data
  );
  return result.data;
};

export const processThumbnail = async (data) => {
  try {
    const result: ProcessThumbnailFromUploadResponseDTO = await axiosInstance.post(
      '/api/v1/publisher/articles/process-thumbnail',
      data
    );
    return result;
  } catch (error) {
    console.error('Error uploading asset:', error);
    throw error;
  }
};
